"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorListContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
const defaultErrorList = {
    addError: (0, catalog_core_1.createErrorFunction)('Function of default ErrorList context called: addError'),
    removeError: (0, catalog_core_1.createErrorFunction)('Function of default ErrorList context called: removeError'),
    clearErrors: (0, catalog_core_1.createErrorFunction)('Function of default ErrorList context called: clearErrors'),
    errors: [],
};
exports.ErrorListContext = react_1.default.createContext(defaultErrorList);
//# sourceMappingURL=ErrorListContext.js.map